<template>
    <div style="margin-top:100px">
        <h1>{{$t('zhmm')}}</h1>
        <van-form  label-width="6em">
            <van-field
                    v-model="mobile"
                    type="text"
                    :name="$t('sjhm')"
                    :label="$t('sjhm')"
                    :placeholder="$t('sjhm')"
              
                />
                <van-field
                    v-model="new_password"
                    type="password"
                    :name="$t('pwas')"
                    :label="$t('pwas')"
                    :placeholder="$t('pwas')"
              
                />
                <van-field
                    v-model="password"
                    type="password"
                    :name="$t('qrmm')"
                    :label="$t('qrmm')"
                    :placeholder="$t('qrmm')"
              
                />

                <van-field
                    v-model="email"
                    type="text"
                    :name="$t('zzmmyx')"
                    :label="$t('zzmmyx')"
                    :placeholder="$t('zzmmyx')"
              
                />
                 <van-field
                v-model="code"
                center
                clearable
                :label="$t('yxyzm')"
                :placeholder="$t('yxyzm')"
                >
                <template #button>
                    <van-button size="small" @click="mailboxcode" :disabled ="disabled" type="info">{{boxcode}}</van-button>
                </template>
                </van-field>
                <div style="margin: 16px;">
                <van-button round block type="info" @click="onSubmit" native-type="submit">{{$t('tj')}}</van-button>
            </div>
        </van-form>
    </div>
</template>
<script>
import { Toast } from 'vant';
import axios from 'axios'
import qs from 'qs'
import MD5 from 'md5'
export default {
    data(){
        return{
            mobile:'',
            new_password:'',
            password:'',
            email:'',
            code:'',
            disabled:false,
            boxcode:this.$t('hqyxyzm')
        }
    },
    methods:{
        //提交
        onSubmit(){
            if(this.new_password !=this.password){
                Toast.fail(this.$t('lcmmbyc'));
                return false
            }
            let data ={
                method:'acs.password.reset',
                mobile:this.mobile,
                new_password:MD5(this.new_password),
                email:this.email,
                code:this.code,
                platform:"pwa"
            }
            this.$serve(data).then(res=>{
                if(res.data.code==0){
                    Toast.success(this.$t('xgcg'));
                    this.$router.push({ path: '/login' })
                }else{
                    Toast.fail(this.$t('xgsb'));
                }
            })
        },
        // 获取邮箱验证码
        mailboxcode(){
            if(!this.email){
                Toast.fail(this.$t('qtxyxyx'));
                return false
            }
            let data = {
                method:'email.send',
                subject:'修改密码',
                to_address:this.email,
                content:'验证码是'
            }
            data = qs.stringify(data)
            axios.post('https://web.fondcard.net/open/email/email.php',data).then(res=>{
                if(res.data.code==0){

                    this.boxcode = this.$t('lsmhhq')
                    this.disabled = true
                    var second = 10
                    var clearTimeSet=setInterval( () =>{
                        this.times = second+'s'
                        second=second-1
                    if(second==0){
                        clearInterval(clearTimeSet);
                        this.disabled = false
                        this.boxcode=this.$t('hqyxyzm')
                    }
                    }, 1000);

                    Toast.success(this.$t('hqyyyzmcg'));
                }
            })
            // let data={
            //     method:'email.send',
            //     subject:'修改密码',
            //     to_address:this.email,
            //     content:'验证码是'
            // }
            // this.$http(data).then(res=>{
            //     if(res.data.code==0){

            //         this.boxcode = this.$t('lsmhhq')
            //         this.disabled = true
            //         var second = 10
            //         var clearTimeSet=setInterval( () =>{
            //             this.times = second+'s'
            //             second=second-1
            //         if(second==0){
            //             clearInterval(clearTimeSet);
            //             this.disabled = false
            //             this.boxcode=this.$t('hqyxyzm')
            //         }
            //         }, 1000);

            //         Toast.success(this.$t('hqyyyzmcg'));
            //     }
            // })
        }
    }
}
</script>